import { z } from "zod";

export default z.object({ "id": z.number().int().describe("태깅 ID"), "empNo": z.number().int().describe("사원 ID"), "recordDt": z.string().describe("기록 일시"), "gateId": z.string().describe("Gate ID"), "gateName": z.string().describe("Gate 이름"), "gateDirection": z.enum(["IN","OUT"]).describe("Gate 방향") }).describe("결세콤 태깅 (게이트 포함)");
